










































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { BModal, BCarousel } from 'bootstrap-vue';
import { Sheet, Examinee, CourseWork, CourseWorkCondition } from "../../modules/teacher/SendAnswerImage"
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';


export interface Data {
  sheet_id: string
  sheet: Sheet
  examinees: Examinee[]
  classroomFields: any[]
  mailFields: any[]
  courseWorkFields: any[]
  isAllChecked: boolean
  selected_ids: number[]
  isMail: boolean
  isClassroom: boolean
  modalExaminee: Examinee
  carouselPageIdx: number
  windowHeight: number
  isShowCarousel: boolean
  isAllCheckedStopPublishing: boolean
  errors: string[]
  oauthWindow: any
  oauthWindowCloseWatcher: number
  run_at: string
  isIosSafari: boolean
  courseWorks: CourseWork[]
  filteredCourseWorks: CourseWork[]
  courseWorkCondition: CourseWorkCondition
  returnType: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    const ApiTypeEnum = Common.ApiTypeEnum;
    const ClassroomReturnTypeEnum = Common.ClassroomReturnTypeEnum;

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const reservationModalRef = ref<InstanceType<typeof BCarousel>>();
    const courseWorkModalRef = ref<InstanceType<typeof BCarousel>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: new Sheet({}),
      examinees: new Array<Examinee>(),
      classroomFields: [
        {key: "select", label: "選択", class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", class: 'text-center b-table-th-td'},
        {key: "room_name", label: "クラス", class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", class: 'text-center b-table-th-td'},
        {key: "student_no_character", label: "学籍番号", class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", class: 'text-center b-table-th-td'},
        {key: "score", label: "得点", class: 'text-center b-table-th-td'},
        {key: "last_sent_at", label: "返却日時", class: 'text-center b-table-th-td'},
        {key: "is_stop_publishing", label: "公開停止", class: 'text-center b-table-th-td'},
        {key: "preview", label: "答案", class: 'text-center'},
      ],
      mailFields: [
        {key: "select", label: "選択", class: 'text-center b-table-th-td'},
        {key: "room_name", label: "クラス", class: 'text-center b-table-th-td'},
        {key: "student_no", label: "出席番号", class: 'text-center b-table-th-td'},
        {key: "student_no_character", label: "学籍番号", class: 'text-center b-table-th-td'},
        {key: "student_name", label: "氏名", class: 'text-center b-table-th-td'},
        {key: "email", label: "Mail", class: 'text-center b-table-th-td'},
        {key: "score", label: "得点", class: 'text-center b-table-th-td'},
        {key: "last_sent_at", label: "返却日時", class: 'text-center b-table-th-td'},
        {key: "is_stop_publishing", label: "公開停止", class: 'text-center b-table-th-td'},
        {key: "preview", label: "答案", class: 'text-center'},
      ],
      courseWorkFields: [
        {key: "title", label: "課題名", class: 'text-center b-table-th-td'},
        {key: "creation_time", label: "作成日時", class: 'text-center b-table-th-td'},
        {key: "update_time", label: "最終更新日時", class: 'text-center b-table-th-td'},
        {key: "select", label: "選択", class: 'text-center'},
      ],
      isAllChecked: false,
      selected_ids: [],
      isMail: context.root.$route.path.indexOf("mail") != -1,
      isClassroom: context.root.$route.path.indexOf("classroom") != -1,
      modalExaminee: new Examinee({}),
      carouselPageIdx: 0,
      windowHeight: 0,
      isShowCarousel: false,
      isAllCheckedStopPublishing: false,
      errors: [],
      oauthWindow: null,
      oauthWindowCloseWatcher: null,
      run_at: null,
      isIosSafari: false,
      courseWorks: [],
      filteredCourseWorks: [],
      courseWorkCondition: new CourseWorkCondition,
      returnType: null,
    });

    /************************************************************
     * テーブルフィールド
     ************************************************************/

    const tableFields = computed(() => {
      return state.isMail ? state.mailFields : state.isClassroom ? state.classroomFields : [];
    });

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    const formatCourseWorkDateTime = (dateTime: string) => {
      return dateTime ? moment(dateTime).format('YYYY年MM月DD日 HH:mm:ss') : "";
    };

    /************************************************************
     * 生徒一覧のcss
     ************************************************************/

    const rowStyle = (idx: number, examinee: Examinee) => {
      const rtn: any = idx % 2 == 1 ? {'background-color': '#f2f2f2'} : {'background-color': 'white'};
      if(examinee.returnCompleted){
        rtn["text-decoration"] = "line-through";
      }
      return rtn;
    }

    /************************************************************
     * 答案返却ボタン押下(Mail)
     ************************************************************/

    const sendAnswerImageMail = async () => {

      if (state.selected_ids.length == 0) {
        alert('答案返却対象の生徒を選択してください。');
        return;
      }

      if (state.isMail && state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id) && !x.email).length > 0) {
        alert('メールアドレスが設定されていない生徒が選択されています。\n生徒一覧から設定してください。');
        return;
      }

      if (!confirm('選択された生徒に答案を返却します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay", {overlayText: "答案返却中。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。", isShowProgress: true});

      let completedCount = 0;

      // 生徒1名単位で返却APIを呼び出す
      for(let i = 0; i < state.examinees.length; i++){

        const examinee = state.examinees[i];
        
        // 未選択生徒はスキップ
        if(!state.selected_ids.includes(examinee.id)){
          continue;
        }

        const params = {sheet_id: state.sheet_id, examinee: examinee};

        await http.post(`/api/teacher/send_answer_image/create_mail`, params).then(response => {

          // 返却日時を更新
          examinee.last_sent_at = Common.formatDate(response.data.last_sent_at, 'yyyy年MM月DD日 HH:mm:ss');
          examinee.returnCompleted = true;
          context.root.$set(state.examinees, i, examinee);
          completedCount++;
          context.root.$store.commit("setProgressText", Number.parseFloat(`${completedCount * 100 / state.selected_ids.length}`).toFixed(2));
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。返却に成功した生徒は返却日時が更新されています。失敗した生徒は再度返却を行ってください。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          return;
        }
      }

      await resolveAfterMilliSeconds();

      alert("処理が完了しました。");
      context.root.$store.dispatch("hideOverlay");
      context.root.$store.dispatch('goSheetList');
    }

    /************************************************************
     * Classroom用 答案返却ボタン押下
     ************************************************************/

    const sendAnswerImageClassroom = async () => {

      state.errors = [];

      if (state.selected_ids.length == 0) {
        alert('答案返却対象の生徒を選択してください。');
        return;
      }

      if(state.returnType == null){
        alert("返却先を選択してください。");
        return;
      }

      if (!confirm('選択された生徒に答案を返却します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay", {overlayText: "答案返却中。画面を閉じずにそのままお待ちください。途中で画面を閉じると処理が中断されます。", isShowProgress: true});

      const examinees = state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).map((x: Examinee) => new Examinee(x));
      const params = {
        course_id: state.sheet.course_id,
        examinees: examinees,
        return_type: state.returnType,
        credentials: context.root.$store.state.gauthCredentials,
      };

      // エラーチェック
      await http.post(`/api/teacher/send_answer_image/class_room_error_check/${state.sheet_id}`, params).then(response => {
        if (response.data.error_type == "gapiAuthError") {
          alert("googleapiの認証に失敗しました。試験一覧に戻ります。");
          context.root.$store.dispatch('goSheetList');
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      // エラーありの場合は処理終了
      if(state.errors.length > 0){
        context.root.$store.dispatch("hideOverlay");
        return;
      }

      let completedCount = 0;

      const aleadyReturnedExaminees: Examinee[] = []

      // 生徒1名単位で返却APIを呼び出す
      for(let i = 0; i < state.examinees.length; i++){

        const examinee = state.examinees[i];
        
        // 未選択生徒はスキップ
        if(!state.selected_ids.includes(examinee.id)){
          continue;
        }

        const params = {
          course_id: state.sheet.course_id,
          examinee: examinee,
          return_type: state.returnType,
          credentials: context.root.$store.state.gauthCredentials,
        };

        await http.post(`/api/teacher/send_answer_image/class_room_return_image/${state.sheet_id}`, params).then(response => {
          if (response.data.error_type == "gapiAuthError") {
            alert("googleapiの認証に失敗しました。試験一覧に戻ります。");
            context.root.$store.dispatch('goSheetList');
          }

          // 既に返却済みで返却スキップしたか判定し処理を分岐
          if(response.data.is_already_returned){
            // スキップしている場合はスキップ生徒集計用の配列に追加
            aleadyReturnedExaminees.push(examinee);
          }else{
            // スキップせず返却処理が実行された場合は生徒の送信日時情報を更新
            examinee.last_sent_at = Common.formatDate(response.data.last_sent_at, 'yyyy年MM月DD日 HH:mm:ss');
            examinee.returnCompleted = true;
            context.root.$set(state.examinees, i, examinee);
          }
          
          completedCount++;
          context.root.$store.commit("setProgressText", Number.parseFloat(`${completedCount * 100 / state.selected_ids.length}`).toFixed(2));
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。返却に成功した生徒は返却日時が更新されています。失敗した生徒は再度返却を行ってください。"];
          }
        });

        // エラーありの場合は処理終了
        if(state.errors.length > 0){
          context.root.$store.dispatch("hideOverlay");
          return;
        }
      }

      await resolveAfterMilliSeconds();

      if(aleadyReturnedExaminees.length > 0){
        alert("処理が完了しました。既に返却済みの生徒が含まれていたため、返却済み生徒は処理をスキップしました。");
      }else{
        alert("処理が完了しました。");
      }
      
      context.root.$store.dispatch("hideOverlay");
      context.root.$store.dispatch('goSheetList');
      
    };

    const resolveAfterMilliSeconds = () => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve('resolved');
        }, 1);
      });
    }


    /************************************************************
     * Classroom用 返却予約ボタン押下
     ************************************************************/

    const stopOauthWindowCloseWatcher = () => {
      if(state.oauthWindowCloseWatcher != null){
        clearInterval(state.oauthWindowCloseWatcher);
        state.oauthWindowCloseWatcher = null;
      }
    }

    const startOauthWindowCloseWatcher = () => {
      stopOauthWindowCloseWatcher();
      state.oauthWindowCloseWatcher = window.setInterval(() => {
        if(state.oauthWindow == null){
          return;
        }

        if(state.oauthWindow.closed){
          stopOauthWindowCloseWatcher();
          state.oauthWindow = null;
          context.root.$store.dispatch("hideOverlay");
        }
      }, 300);
    }

    const reservationClick = async () => {

      state.errors = [];
      state.oauthWindow  = null;
      window.removeEventListener("message", handleMessage);
      window.addEventListener("message", handleMessage);

      if (state.selected_ids.length == 0) {
        alert('予約対象の生徒を選択してください。');
        return;
      }

      if(state.returnType == null){
        alert("返却先を選択してください。");
        return;
      }

      const examinees = state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).map((x: Examinee) => new Examinee(x));
      const params = {
        sheet_id: state.sheet_id,
        course_id: state.sheet.course_id,
        examinees: examinees,
        return_type: state.returnType,
        is_reservation: true,
      };

      context.root.$store.dispatch("showOverlay");

      // iOS Safari 対策：awaitの処理の後ではポップアップブロックされるので先に空ウィンドウを開く
      if (state.isIosSafari) {
        state.oauthWindow = window.open('', 'google_oauth', 'width=500,height=650');
        startOauthWindowCloseWatcher();
      }

      // 予約用の認証が必要か判定
      let forceConsent = false;
      await http.get(`/api/classroom_sessions/force_consent?`).then(response => {
        forceConsent = response.data.force_consent;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      // エラーありの場合は処理終了
      if(state.errors.length > 0){
        context.root.$store.dispatch("hideOverlay");
        return;
      }

      const reservationErrorCheck = async () => {
        state.errors = [];
        context.root.$store.dispatch("showOverlay");

        await http.post(`/api/teacher/send_answer_image/class_room_error_check/${state.sheet_id}`, params).then(response => {
          if (response.data.error_type == "gapiAuthError") {
            alert("googleapiの認証に失敗しました。試験一覧に戻ります。");
            context.root.$store.dispatch('goSheetList');
          }
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });

        context.root.$store.dispatch("hideOverlay");

        if(state.errors.length > 0){
          return;
        }

        reservationModalRef.value.show();
      }

      if(forceConsent){
        context.root.$nextTick(() => {
          document.cookie = "api_kind=send_answer_image_classroom";

          if (state.isIosSafari) {
            state.oauthWindow.location.href = `/api/classroom_sessions/create_by_send_answer_image?id=${context.root.$store.state.currentUser.id}`;
          }else{
            alert("返却予約を登録するには再認証が必要です。");
            state.oauthWindow = window.open(
              `/api/classroom_sessions/create_by_send_answer_image?id=${context.root.$store.state.currentUser.id}`,
              "google_oauth",
              "width=500,height=650"
            )
            startOauthWindowCloseWatcher();
          }
        });
      }else{
        if (state.isIosSafari) {
          state.oauthWindow?.close();
        }
        await reservationErrorCheck();
      }
    }

    /************************************************************
    * Gアカウント認証用サブウィンドウの完了通知待ちイベント
    ************************************************************/
    const handleMessage = async (event: MessageEvent) => {
      if (event.origin !== window.location.origin){
        return;
      }

      if(event.data.key === "oAuth"){
        if(event.data.result === "success"){
          // 認証成功の場合はusers保存済みtokenで事前チェック後に予約日時設定モーダルを表示
          window.removeEventListener("message", handleMessage);
          stopOauthWindowCloseWatcher();
          state.oauthWindow?.close();
          context.root.$store.commit("setGauthCredentials", event.data.credentials);
          const examinees = state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).map((x: Examinee) => new Examinee(x));
          const params = {
            sheet_id: state.sheet_id,
            course_id: state.sheet.course_id,
            examinees: examinees,
            return_type: state.returnType,
            is_reservation: true,
          };
          context.root.$store.dispatch("showOverlay");
          await http.post(`/api/teacher/send_answer_image/class_room_error_check/${state.sheet_id}`, params).then(response => {
            if (response.data.error_type == "gapiAuthError") {
              alert("googleapiの認証に失敗しました。試験一覧に戻ります。");
              context.root.$store.dispatch('goSheetList');
            }
          })
          .catch(error=>{
            if(error.response.status == 422){
              state.errors = error.response.data.errors;
            }else{
              state.errors = ["予期せぬ例外が発生しました。"];
            }
          });
          context.root.$store.dispatch("hideOverlay");
          if(state.errors.length == 0){
            reservationModalRef.value.show();
          }
        }else{
          // 認証失敗の場合はエラーメッセージを表示
          window.removeEventListener("message", handleMessage);
          stopOauthWindowCloseWatcher();
          state.oauthWindow?.close();
          context.root.$store.dispatch("hideOverlay");
          state.errors.push(event.data.message);
        }
      }
    }

    /************************************************************
    * Classroom用 返却予約登録
    ************************************************************/

    const entryReservation = async () => {
      
      state.errors = [];

      if(!window.confirm("選択している生徒への答案返却予約を登録します。よろしいですか？")){
        return;
      }

      // 予約日時の文字列を"2025-06-19 17:08" → "2025-06-19T17:08:00" に変換（ISO8601形式）
      const targetDate = new Date(state.run_at.replace(' ', 'T'));
      if(targetDate < new Date() && !window.confirm("予約日時に過去の日時を設定しています。この予約は即時実行されます。よろしいですか？")){
        return;
      }

      reservationModalRef.value.hide();

      const examinees = state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).map((x: Examinee) => new Examinee(x));
      const params = {
        examinees: examinees,
        return_type: state.returnType,
        run_at: state.run_at
      };

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/send_answer_image/entry_classroom_reservation/${state.sheet_id}`, params).then(response => {
        alert("処理が完了しました。");
        state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).forEach(x => {
          x.run_at = Common.formatDate(state.run_at, 'yyyy年MM月DD日 HH:mm:ss 返却予定');
          x.is_reservation_send_error = false;
        });
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
    * Classroom用 返却予約取り消し
    ************************************************************/

    const deleteReservationClassroom = async () => {
      
      state.errors = [];

      if (state.selected_ids.length == 0) {
        alert('予約対象の生徒を選択してください。');
        return;
      }

      if(!window.confirm("選択している生徒の答案返却予約を取り消します。よろしいですか？")){
        return;
      }

      const examinees = state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).map((x: Examinee) => new Examinee(x));
      const params = {examinees: examinees};

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/send_answer_image/delete_classroom_reservation/${state.sheet_id}`, params).then(response => {
        alert("処理が完了しました。");
        state.examinees.filter((x: Examinee) => state.selected_ids.includes(x.id)).forEach(x => x.run_at = null);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 公開状態更新
     ************************************************************/

    const updatePublishing = async () => {

      if (!confirm('公開停止状態を更新します。よろしいですか？')) {
        return;
      }

      await http.post(`/api/teacher/send_answer_image/update_stop_publishing`, {sheet_id: state.sheet_id, examinees: state.examinees}).then(response => {
        alert("処理が完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");

    };

    /************************************************************
     * モーダルのtitleを返却
     ************************************************************/

    const modalTitle = computed((): string => {
      if(state.modalExaminee == null){
        return "";
      }

      if(state.isMail){
        return `採点結果　クラス名：${state.modalExaminee.room_name}　出席番号：${state.modalExaminee.student_no}番　氏名：${state.modalExaminee.student_name}`;
      }else if(state.isClassroom){
        return `採点結果　コース名：${state.modalExaminee.course_name}　クラス名：${state.modalExaminee.room_name}　出席番号：${state.modalExaminee.student_no}番　氏名：${state.modalExaminee.student_name}`;
      }
    });

    /************************************************************
     * 画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (examinee: Examinee) => {

      if(examinee.base64Images.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage(examinee)
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }
      state.isShowCarousel = true;
      state.carouselPageIdx = 0;
      state.modalExaminee = examinee;
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async (examinee: Examinee) => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
      await http.get(`/api/teacher/send_answer_image/download_image/${examinee.sheet_id}/${sheetActivityIds}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          examinee.base64Images.push(x);
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/
    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.sheet.page_count - 1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/
    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.sheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };
    
    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx - 1; i >= 0; i--){
        const examinee = state.examinees[i];
        if(examinee.base64Images.length == 0){
          // 画像をダウンロード
          const isSuccess: boolean = await downloadImage(examinee)
          if(!isSuccess){
            // ダウンロード失敗は処理終了
            return;
          }
        }
        state.modalExaminee = examinee;
        carouselRef.value.setSlide(state.carouselPageIdx);
        break;
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx + 1; state.examinees.length; i++){
        const examinee = state.examinees[i];
          if(examinee.base64Images.length == 0){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(examinee)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalExaminee = examinee;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
      }
    };

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      state.windowHeight = windowHeight;
    };

    watch(() => state.isAllChecked, (newVal, oldVal) => {

      state.selected_ids = [];

      if (newVal) {

        state.selected_ids = state.examinees.map(x => x.id);
      }
    });

    watch(() => state.isAllCheckedStopPublishing, (newVal, oldVal) => {
      state.examinees.forEach(x => x.is_stop_publishing = newVal);
    });

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      
      let method = "";
      if(state.isClassroom){
        method = "index_classroom";
      }else{
        method = "index_mail";
      }
      
      await http.get(`/api/teacher/send_answer_image/${method}?sheet_id=${state.sheet_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.examinees = response.data.examinees.map((x: any) => new Examinee(x));
        state.examinees.forEach((examinee: Examinee) => {
          state.selected_ids.push(examinee.id);
        });
        state.isAllChecked = true;

        const ua = navigator.userAgent;
        state.isIosSafari = /Safari/.test(ua) && !/Chrome/.test(ua) && !/CriOS/.test(ua) && !/FxiOS/.test(ua);
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch('goSheetList');
      });
      context.root.$store.dispatch("hideOverlay");

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("message", handleMessage);
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("message", handleMessage);
      stopOauthWindowCloseWatcher();
    });

    return {
      ...toRefs(state),
      ApiTypeEnum,
      ClassroomReturnTypeEnum,
      modalRef,
      carouselRef,
      reservationModalRef,
      courseWorkModalRef,
      convertExecDateText,
      formatCourseWorkDateTime,
      tableFields,
      modalTitle,
      showPreviewImage,
      carouselPrev,
      carouselNext,
      changePrevModalExaminee,
      changeNextModalExaminee,
      adjustHeight,
      updatePublishing,
      sendAnswerImageClassroom,
      rowStyle,
      sendAnswerImageMail,
      reservationClick,
      entryReservation,
      deleteReservationClassroom,
    }
  }
});

